import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Navigation from './components/Navigation/Navigation';
import Footer from "./components/Footer/Footer";
import UnderDev from "./pages/UnderDev";
import BoardOfDirectors from './pages/BoardOfDirectors';
import Promoters from './pages/Promoters'; 
import KeyManagerialPersonnel from './pages/KeyManagerialPersonnel'; // Import the new component
import Careers from './pages/Careers';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navigation />

        {/* A wrapper for your main content that can flex-grow */}
        <div className="App-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<UnderDev />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/gallery" element={<UnderDev />} />
            <Route path="/electrical-works" element={<UnderDev />} />
            <Route path="/civil-works" element={<UnderDev />} />
            <Route path="/board-of-directors" element={<BoardOfDirectors />} />
            <Route path="/promoters" element={<Promoters />} />
            <Route path="/key-managerial-personnel" element={<KeyManagerialPersonnel />} /> {/* Add the new route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>

        {/* Footer stays at the bottom */}
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;